import React from "react";
import FaqHero from "../components/faq/FaqHero";
import FaqSection from "../components/faq/FaqSection";

const Faq = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <FaqHero />
      <FaqSection />
    </div>
  );
};

export default Faq;
